import { Component } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { SetDpParams } from "src/app/store/actions/global-subheader.actions";
import { AppState, stateGetter } from "src/app/store/state/app.state";

@Component({
  selector: "app-va-core-formulabar",
  templateUrl: "./va-core-formulabar.component.html",
  styleUrls: ["./va-core-formulabar.component.scss"],
})
export class VaCoreFormulabarComponent {
  validateForm!: UntypedFormGroup;
  dpCallObj;
  load: boolean = false;
  apiEP: string = window.apiUrl;
  submitForm(): void {
    if (this.validateForm.valid) {
      this.loadOldFormulaBar();
      this.loadNewFormulaBar();
    } else {
      Object.values(this.validateForm.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  constructor(
    private fb: UntypedFormBuilder,
    private store: Store<AppState>,
    private router: Router,
  ) {
    store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        const userEmail = data.userDetails ? data.userDetails.email : "";
        if (userEmail !== "" && !userEmail.includes("@visiblealpha.com")) {
          //redirect to home
          this.router.navigateByUrl("home");
        }
      });
  }

  ngOnInit(): void {
    // get_fb?dp=16202121254%7C1/17/2024&original_cut=STD&cut=STD&source=consensus&ticker=DAL&shouldLog=true&currency=USD&period=CY-2024&growthType=Analytics&extras=16202121254%7CCY-2024 -->

    this.validateForm = this.fb.group({
      dp: [null, [Validators.required]],
      cut: [null, [Validators.required]],
      source: [null, [Validators.required]],
      ticker: [null, [Validators.required]],
      currency: [null, []],
      period: [null, [Validators.required]],
      growthType: [null, [Validators.required]],
      revision: [null, []],
      original_cut: [null, []],
      historical_focus: [null, []],
      is_universalsliid: [null, []],
      tpr_page: [null, []],
      pg: [null, []],
      param: [null, []],
      incl_sources: [null, []],
      excl_sources: [null, []],
      extras: [null, [Validators.required]],
    });
  }

  loadOldFormulaBar() {
    const dpParams = {
      ...this.validateForm.value,
      shouldLog: true,
    };
    this.store.dispatch(new SetDpParams(dpParams));
  }
  loadNewFormulaBar() {
    this.load = true;
    const dpParams = {
      ...this.validateForm.value,
      shouldLog: true,
    };
    this.dpCallObj = {
      ...dpParams,
    };
    delete this.dpCallObj.historical_focus;
    delete this.dpCallObj.original_cut;
    delete this.dpCallObj.pg;
    delete this.dpCallObj.param;
  }

  callForDummyData() {
    const dpParams = this.setDummyData();
    this.store.dispatch(new SetDpParams(dpParams));
    this.load = true;
    this.dpCallObj = {
      ...dpParams,
    };
    delete this.dpCallObj.historical_focus;
    delete this.dpCallObj.original_cut;
    delete this.dpCallObj.pg;
    delete this.dpCallObj.param;
  }
  setDummyData() {
    return {
      dp: "12454858695|01/24/2024",
      cut: "NMV",
      source: "Consensus",
      ticker: "DAL",
      currency: null,
      period: "FY-2024",
      growthType: "Analytics",
      revision: null,
      extras: "12454858695|fy-2024consensus",
      shouldLog: true,
    };
    // // STD
    // return {
    //   isdebug: true,
    //   dp: "ed48a78e92568d56|01/18/2024",
    //   cut: "STD",
    //   original_cut: "STD",
    //   source: "Consensus",
    //   ticker: "005930_KR",
    //   pg: "IS",
    //   historical_focus: 'VA Actuals',
    //   param: 190,
    //   period: "FY-2023",
    //   growthType: "yoy%",
    //   extras: "ed48a78e92568d56|fy-2023currentconsensus",
    //   shouldLog: true,
    // };
    // NMV -- no data
    // return {
    //   isdebug: true,
    //   dp: "16191624795|01/18/2029",
    //   cut: "NMV",
    //   original_cut: "NMV",
    //   source: "Consensus",
    //   ticker: "005930_KR",
    //   pg: "SG",
    //   historical_focus: 'VA Actuals',
    //   param: 12672309,
    //   period: "FY-2023",
    //   growthType: "trend",
    //   extras: "16191624795|01/18/2029",
    //   shouldLog: true,
    // };
    // NMV
    // return {
    //   isdebug: true,
    //   dp: "ed48a78e92568d56|01/18/2024",
    //   cut: "NMV",
    //   original_cut: "NMV",
    //   source: "Consensus",
    //   ticker: "005930_KR",
    //   pg: "SG",
    //   historical_focus: 'VA Actuals',
    //   param: 12672309,
    //   period: "FY-2023",
    //   growthType: "yoy%",
    //   extras: "ed48a78e92568d56|fy-2023currentconsensus",
    //   shouldLog: true,
    // };
    // return {
    //   isdebug: true,
    //   dp: "4976bfea94531045|01/18/2024",
    //   cut: "NMV",
    //   original_cut: "NMV",
    //   source: "Consensus",
    //   ticker: "005930_KR",
    //   pg: "SG",
    //   historical_focus: 'VA Actuals',
    //   param: 12672309,
    //   period: "FY-2023",
    //   growthType: "seq%",
    //   extras: "4976bfea94531045|fy-2023currentconsensus",
    //   shouldLog: true,
    // };
    // SAR -- not available in sheet
    // return {
    //   isdebug: true,
    //   dp: "14980394143|02/13/2024",
    //   cut: "SAR",
    //   original_cut: "SAR",
    //   source: "Barclays",
    //   ticker: "DAL",
    //   pg: "BalanceSheet",
    //   historical_focus: 'VA Actuals',
    //   param: 6380131,
    //   period: "FY-2019",
    //   growthType: "analytics",
    //   extras: "14980394143|fy-2019",
    //   shouldLog: true,
    // };
    // custom consensus
    // return {
    //   isdebug: true,
    //   dp: "16191624795|01/17/2024",
    //   cut: "STD",
    //   original_cut: "STD",
    //   source: "custom",
    //   ticker: "005930_KR",
    //   pg: "IS",
    //   historical_focus: 'VA Actuals',
    //   param: 190,
    //   period: "FY-2023",
    //   incl_sources: "[138,3,149,10]",
    //   excl_sources: "[44,206,56,255,4,194,2,1,75,196,59,17,199,223,171,89,11]",
    //   growthType: "analytics",
    //   extras: "16191624795|fy-2023currentcustom",
    //   shouldLog: true,
    // };

    // -------------https://visiblealpha.atlassian.net/browse/CORE-1201----------------
    // return {
    //   isdebug: true,
    //   dp: "9beb5f27e3f1f375|02/16/2024",
    //   cut: "NMV",
    //   original_cut: "NMV",
    //   source: "Consensus",
    //   ticker: "005930_KR",
    //   pg: "SG",
    //   historical_focus: 'VA Actuals',
    //   param: 12672309,
    //   period: "FY-2023",
    //   growthType: "seq%",
    //   extras: "9beb5f27e3f1f375|fy-2023currentconsensus",
    //   shouldLog: true,
    // };
    // valuation page
    // return {
    //   isdebug: true,
    //   dp: "VLR_30|2/16/2024",
    //   cut: "STD",
    //   original_cut: "STD",
    //   source: "Consensus",
    //   ticker: "DAL",
    //   period: "NTM",
    //   growthType: "Analytics",
    //   extras: "VLR_30|NTM",
    //   shouldLog: true,
    // };
  }
}
